var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dynamic-tag', {
    staticClass: "Polaris-ActionList",
    attrs: {
      "tag": _vm.hasMultipleSections ? 'div' : 'ul'
    }
  }, _vm._l((_vm.finalSections), function(section, index) {
    return _c('polaris-action-list-section', {
      key: index,
      attrs: {
        "section": section,
        "has-multiple-sections": _vm.hasMultipleSections
      },
      on: {
        "action-any-item": _vm.onActionAnyItem
      }
    })
  }))
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-07f75813", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07f75813","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisActionList.vue
// module id = 145
// module chunks = 0